// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "../dist/js/" + chunkId + "." + {"856":"a463839a","935":"dc4bb9b9"}[chunkId] + ".js";
};